/**
 * Extracts the main domain from the current URL.
 * 
 * @function
 * @name getMainDomainFromCurrentUrl
 * @returns {string}
 * @description
 * Retrieves the hostname from the browser's `window.location.hostname`.
 * Intention is to identify the primary domain of a website, while ignoring subdomains.
 * @example `bmo.com` = returns => `.bmo.com` & `about.bmo.com` => returns => `.bmo.com`
 * 
 * @author Jaskiran Chhokar
 */

const getMainDomainFromCurrentUrl = (): string => {
    const hostname = window.location.hostname;
    const parts = hostname.split('.');
    if(parts.length <= 2) {
        return hostname;
    }
    return `.${parts.slice(-2).join('.')}`;
};

export default getMainDomainFromCurrentUrl;